import styled from 'styled-components';

const RatingStarsContainer = styled.div`
  display: flex;
  justify-content: 'normal';

  > svg {
    margin: 0 ${({ theme }) => theme.size / 8}px;

    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

export default RatingStarsContainer;
export { RatingStarsContainer };
